import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '../errors'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        gcTime: 5 * 60_000,
        // The client already retries transient GET failures; one more try at the query level, never for 4xx.
        retry: (count, err) => !(isApiError(err) && err.isClientError) && count < 1,
      },
      mutations: { retry: false },
    },
  })
}
